import {fontFamilies, FontFamilyType} from '../../models/editor/fontFamily'
import {ImgCaption} from '../../models/editor/imgCaption'
import {useAppDispatch} from '../../stores/configureStore'
//@ts-ignore
import {CirclePicker} from 'webtic-react-color'
import css from './colorPickerWrapper.module.css'
import css2 from '../../css/caption.module.css'
import DeleteCaptionButton from './buttons/DeleteCaptionButton'
import AddCaptionButton from './buttons/AddCaptionButton'
import SendBackButton from './buttons/SendBackButton'
import BringForwardButton from './buttons/BringForwardButton'
import MovementArrows from './MovementArrows'
import MirrorArrows from './MirrorArrows'
import {handleUpdatedAttributes} from '../../utils/helpers/attributeHelper'
import Caption1LetterSpacingController from './sliders/Caption1LetterSpacingController'
import Caption2LetterSpacingController from './sliders/Caption2LetterSpacingController'
import CurvatureLevelController from './sliders/CurvatureLevelController'
import RotationController from './sliders/RotationController'
import ScaleController from './sliders/ScaleController'
import ControlGroup from './ControlGroup'
import FontStyleController from './FontStyleController'
import {useTranslation} from 'react-i18next'
import {pickerColors} from '../../constants/pickerColors'

interface CaptionProps {
  img: ImgCaption
  isGraphics?: boolean
}

export default function Caption({img, isGraphics = false}: CaptionProps) {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()

  return (
    <div className={css2.container}>
      <ControlGroup>
        <div className={css2.imagesControls}>
          <DeleteCaptionButton />
          <AddCaptionButton singleLine={isGraphics} />
        </div>
      </ControlGroup>

      <ControlGroup title={t('Sorrend')}>
        <div className={css2.imagesControls}>
          <SendBackButton />
          <BringForwardButton />
        </div>
      </ControlGroup>

      <ControlGroup>
        <div className={css2.charCounterInputWrapper}>
          <input
            className={css2.input}
            type="text"
            value={img.caption1}
            onChange={e => {
              const trunctatedText = e.target.value
                .substring(0, 35)
                .replace(/[\u0400-\uF8FF]/g, '')
              if (trunctatedText.length <= 35) {
                handleUpdatedAttributes(dispatch, img, {
                  caption1: trunctatedText,
                })
              }
            }}
          />
          <div className={css2.charCounter}>{35 - img.caption1.length}/35</div>
        </div>
      </ControlGroup>

      {img.caption2 !== null && (
        <ControlGroup>
          <div className={css2.charCounterInputWrapper}>
            <input
              type="text"
              className={css2.input}
              value={img.caption2}
              onChange={e => {
                const trunctatedText = e.target.value
                  .substring(0, 35)
                  .replace(/[\u0400-\uF8FF]/g, '')
                if (trunctatedText.length <= 35) {
                  handleUpdatedAttributes(dispatch, img, {
                    caption2: trunctatedText,
                  })
                }
              }}
            />
            <div className={css2.charCounter}>
              {35 - img.caption2.length}/35
            </div>
          </div>
        </ControlGroup>
      )}

      <ControlGroup title={t('Betűtípus')}>
        <div className={css2.selectWrapper}>
          <select
            className={css2.input}
            value={img.fontFamily}
            onChange={e => {
              handleUpdatedAttributes(dispatch, img, {
                fontFamily: e.target.value as FontFamilyType,
              })
            }}>
            {fontFamilies.map(fontFamily => (
              <option
                key={`fontFamily_${fontFamily}`}
                value={fontFamily}
                style={{fontFamily: fontFamily}}>
                {fontFamily}
              </option>
            ))}
          </select>
        </div>
      </ControlGroup>

      <ControlGroup title={t('Szín')}>
        <div className={css.colorPickerWrapper}>
          <CirclePicker
            colors={pickerColors as unknown as string}
            color={img.color}
            onChange={(color: any) => {
              const realColor = pickerColors.find(c => c.color === color.hex)
              if (realColor) {
                handleUpdatedAttributes(dispatch, img, {color: color.hex})
              }
            }}
          />
        </div>
      </ControlGroup>

      <FontStyleController img={img} />
      <ScaleController img={img} caption />
      <RotationController img={img} />
      <CurvatureLevelController img={img} />
      <Caption1LetterSpacingController img={img} />
      {img.caption2 !== null && <Caption2LetterSpacingController img={img} />}

      <div className={css2.movementTools}>
        <MovementArrows img={img} />
        <MirrorArrows img={img} />
      </div>
    </div>
  )
}
